import { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DOCTOR } from "@/lib/data";

// This route auto-redirects to Google Maps reviews.
// A short transition panel is shown while the tab opens.
export default function Reviews() {
  useEffect(() => {
    const t = setTimeout(() => {
      window.open(DOCTOR.googleReviewsUrl, "_blank", "noopener,noreferrer");
    }, 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className="min-h-[100svh] bg-navy-600 text-beige-100 flex items-center justify-center px-6 lg:px-12"
      data-testid="reviews-page"
    >
      <div className="max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="text-[10px] uppercase tracking-[0.3em] text-brass-400 mb-6">
            Chapter 05 · Reviews
          </div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight">
            Read what patients say <br />
            <span className="italic text-brass-400">— on Google.</span>
          </h1>
          <p className="mt-8 max-w-lg text-beige-100/70 leading-relaxed">
            Reviews are hosted where they are most trustworthy — the same Google
            listing where Dr. Matai&apos;s practice is verified. A new tab has been
            opened for you.
          </p>
          <a
            href={DOCTOR.googleReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-external-link"
            className="mt-12 inline-flex items-center gap-3 bg-beige-100 text-navy-600 px-7 py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-brass-400 transition-colors"
          >
            Open Google Reviews
            <ArrowUpRight size={16} />
          </a>
        </motion.div>
      </div>
    </div>
  );
}
